import * as Sync from '@nozbe/watermelondb/sync';
import DatabaseService from 'shared/db/services/Database.web';

export const hasUnsyncedChanges = async (): Promise<boolean> => {
    const database = DatabaseService.getDatabase();
    const isUnsynced = await (Sync as any).hasUnsyncedChanges({ database });

    return isUnsynced;
};
